import { createSlice } from "@reduxjs/toolkit";
import {
  changeCompanySubscription,
  changeSubscriptionStatus,
} from "./subscriptionActions";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

const subscriptionSlice = createSlice({
  name: "subscription",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(changeCompanySubscription.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(changeCompanySubscription.fulfilled, (state, action) => {
        state.loading = false;
        const { company_id, subscription_id, no_of_user, no_of_branch } =
          action.payload;

        if (state.data?.company_list) {
          state.data.company_list = state.data.company_list.map((company) =>
            company._id === company_id
              ? {
                  ...company,
                  subscription_id,
                  no_of_user,
                  no_of_branch,
                }
              : company
          );
        }
      })
      //in plan
      .addCase(changeCompanySubscription.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(changeSubscriptionStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(changeSubscriptionStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(changeSubscriptionStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default subscriptionSlice.reducer;
